import { MoreHorizRounded } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, Modal } from '@mui/material'
import React, { useCallback, useState } from 'react'
import './style.scss'
import { History } from './options/History'
import DeleteOrderModal from './options/DeleteOrderModal'
import axiosInstance from '../../../utils/axiosInstance'
import { useSelector } from '../../../store/store'
import { USER_ROLES } from '../../../constants'

interface Props {
  id: string
  type?: string
}

const AdvancedMenu: React.FC<Props> = ({ id, type = '' }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [openModal, setOpenModal] = React.useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const { userInfo } = useSelector((state) => state.user)
  const { role } = userInfo

  // Check if user is internal (admin or internal user)
  const isInternalUser = [
    USER_ROLES.ADMIN.value,
    USER_ROLES.INTERNAL_USER.value,
    USER_ROLES.INTERNAL_USER_LIMITED.value,
  ].includes(role || '')

  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    handleCloseModal()
  }

  const handleClickHistoryOption = () => {
    setAnchorEl(null)
    handleOpenModal()
  }

  const handleClickDeleteOption = () => {
    setAnchorEl(null)
    setDeleteModalOpen(true)
  }

  const handleDownloadCB = useCallback(() => {
    const url = `/campaign/${id}/download`
    axiosInstance
      .get(url, {
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const fileName = `campaign_${id}.csv`
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
      })
      .catch((error) => {
        throw new Error(error)
      })
      .finally(() => {
        handleCloseModal()
      })
  }, [id])

  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  const handleDeleteConfirm = () => {
    setDeleteModalOpen(false)
  }

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false)
  }

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreHorizRounded />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {type === 'lead' ? (
          <div>
            <MenuItem onClick={() => {}}>Edit</MenuItem>
            <MenuItem onClick={handleDownloadCB}>Download</MenuItem>
          </div>
        ) : (
          <div>
            <MenuItem onClick={handleClickHistoryOption}>History</MenuItem>
            {isInternalUser && type === 'order' && (
              <MenuItem onClick={handleClickDeleteOption} sx={{ color: 'error.main' }}>
                Delete
              </MenuItem>
            )}
          </div>
        )}
      </Menu>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <History id={id} handleClose={() => handleClose()} />
        </div>
      </Modal>

      <DeleteOrderModal
        open={deleteModalOpen}
        orderId={id}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
      />
    </div>
  )
}

export default AdvancedMenu
